<template>
  <el-tooltip
    v-if="recommendationMapping[recommendationKey]"
    popper-class="tooltip-proto-score"
    placement="top">
    <label
      :class="[recommendationMapping[recommendationKey].class, small?'small':'']"
      class="protoLabel"
    >
      <font-awesome-icon :icon="recommendationMapping[recommendationKey].icon" class="icon" :class="isMini ? '' : 'with-text'"/>
      <template
        v-if="!isMini"
      >{{ recommendationMapping[recommendationKey].label }}
      </template>
    </label>
    <div slot="content">
      <div v-if="displayDetails" class="tooltip">
        <label :class="recommendationMapping[recommendationKey].class">{{ recommendation }}</label>
        <template v-if="recommendationMapping[recommendationKey].displayScore">

          <p v-for="component in scoreComponents" :key="component.label" class="score-component">
            <span class="score-label">{{ component.label }}</span>
            <span class="score-value"><b>{{ component.value != null ? (+component.value).toFixed(1) : 'N/A' }}</b></span>
          </p>
          <span class="score-component score-total">
            <span class="score-label"><h1>Total Score</h1></span>
            <span class="score-value"><h1><b>{{ score.toFixed(1) }}</b></h1></span>
          </span>
        </template>
      </div>
      <div
        v-else
        class="tooltip"
        v-html="recommendationMapping[recommendationKey].details">
      </div>
    </div>
  </el-tooltip>
</template>

<script>
const { recommendationMapping } = require('./utils');

export default {
  name: 'ProtoScore',
  props: {
    recommendation: {
      type: String,
      required: true,
    },
    displayDetails: {
      type: Boolean,
      default: false,
    },
    score: {
      type: Number,
      default: 0,
    },
    scoreComponents: {
      type: Array,
      default() {
        return [];
      },
    },
    isMini: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      recommendationMapping,
    };
  },
  computed: {
    recommendationKey() {
      return this.recommendation.toLowerCase();
    },
  },
};
</script>

<style lang="scss">
.el-tooltip__popper.tooltip-proto-score {
  background: $tooltip-background-dark;
  padding: 15px;
  color: $white;
  font-weight: bold;
  max-width: 350px;
  border-radius: 5px;

  &[x-placement^="top"] .popper__arrow::after {
    border-top-color: $tooltip-background-dark;
  }

  &[x-placement^="bottom"] .popper__arrow::after {
    border-bottom-color: $tooltip-background-dark;
  }

  .tooltip p {
    line-height: 18px;
  }
}
</style>

<style lang="scss" scoped>
h1 {
  font-size: 12px;
  font-weight: 700;
  text-align: right;
  margin: 4px 0;
}

.score-component {
  display: flex;
  justify-content: space-between;
  font-size: 10px;
  color: $white;

  .score-label {
    font-weight: 400;
    padding-right: 5px;
  }

  .score-value {
    font-weight: 700;
  }

  &.score-total {
    border-top: 1px solid rgba(255, 255, 255, 0.2);
  }
}

label {
  font-weight: 800;
  font-size: 12px;

  svg.with-text {
    margin-right: 4px;
  }

  &.high {
    color: $green-alert;
  }
  &.low {
    color: $orange-alert;
  }
  &.none {
    color: $grey;
  }
}
</style>
